import React from "react";

const PageLoadingMessage = () => {
    return (
        <div className="pageLoadingBackground">
            <h1>Loading...</h1>
        </div>
    );
};

export default PageLoadingMessage;
